import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var xt = /*#__PURE__*/function () {
  function xt(t) {
    _classCallCheck(this, xt);

    this.Hl = t;
  }

  _createClass(xt, [{
    key: "Ql",
    value: function Ql(t) {
      return null == this.Hl || this.Hl === t[0];
    }
  }, {
    key: "ss",
    value: function ss() {
      return this.Hl;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new xt(t ? t.event_name : null);
    }
  }]);

  return xt;
}();

export { xt as default };